<template>
    <div>

        <!-- 表单 -->
        <div class="form"
         v-show="step===1">
            <left-part
            class="left"
            @addComponents="addComponents"></left-part>
            <mid-part
            class="mid"
            :info="activity"
            :componentsList="componentsList"
            :selectedComponent="selectedComponent"
            @selectActivity="selectActivity"
            @selectComponent="selectComponent"
            @removeComponent="removeComponent"></mid-part>
            <right-part
            class="right"
            :info="activity"
            :componentItem="componentItem"
            @setActivityData="setActivityData"
            ></right-part>
        </div>

        <!-- 表单设置 -->
        <form-set
         ref="formSet"
         v-show="step===2"
         @setActivityData="setActivityData">
        </form-set>
        
        <!-- 下一步 -->
        <p style="text-align: center;">
            <el-button type="primary"
             v-show="step===1"
             @click="next">下一步，表单设置</el-button>
            <el-button
             v-show="step===2"
             :loading="saveLoading"
             @click="step=1">上一步</el-button>
            <el-button type="primary"
             v-show="step===2"
             :loading="saveLoading"
             @click="save">保 存</el-button>
        </p>
    </div>
</template>

<script scoped>
    import leftPart from './leftPart'
    import midPart from './midPart'
    import rightPart from './rightPart'
    import formSet from './formset'
    import requestApi from '@/api/operateManage/signupform'
    export default {
        name: "signupform-form",
        components: {
            midPart,
            leftPart,
            rightPart,
            formSet
        },
        data() {
            return {
                step: 1,
                activity: {
                    name: '', // 表单名称
                    banner: '', // 封面图
                    descInfo: '', // 介绍信息
                    submitBtnTxt: '' // 提交按钮
                },
                componentsList: [],
                del_componentsList: [], // 已删除的组件
                selectedComponent: null,
                saveLoading: false
            }
        },
        computed: {
            componentItem() {
                return this.selectedComponent || this.activity
            }
        },
        methods: {
            // 设置活动信息
            setActivityData(data) {
                if(data.key) {
                    this.activity[data.key] = data.value
                } else {
                    this.activity = data.value
                    this.$refs.formSet.setActivityData(data.value)
                }
            },

            // 设置表单信息
            // setFormsetData(data) {

            // },

            // 设置组件信息
            setComponentList(data) {
                this.componentsList = data
            },

            // 选择活动
            selectActivity() {
                this.selectedComponent = null
            },

            // 选择组件
            selectComponent(index) {
                this.selectedComponent = this.componentsList[index]
            },

            // 添加组件
            addComponents(data) {
                if(data.unique) { // 如果是唯一组件
                    // 是否已存在该组件
                    let isExsit = this.componentsList.some((current) => {
                        return current.name === data.name
                    })
                    if(isExsit) {
                        this.$message.warning('此选项只能支持一个')
                        return
                    }
                }
                
                let newData = JSON.parse(JSON.stringify(data))
                
                newData.fieldId = new Date().getTime()
                this.selectedComponent = newData
                this.componentsList.push(newData)
            },

            // 移除组件
            removeComponent(index, item) {

                // 删除选中项
                this.componentsList.splice(index, 1)
                if(isNaN(item.fieldId)) {
                    item.delFlag = 1 // delFlag  删除标识（0-未删除 1-删除）
                    item.chName = item.chName + '(已删)'
                    this.del_componentsList.push(item)
                }


                if(!this.selectedComponent) {
                    return

                // 删除的项是当前选中项, 并且删除项有上一项
                } else if (this.selectedComponent.fieldId === item.fieldId
                 && index > 0) {
                    this.selectedComponent = this.componentsList[index - 1]
                
                // 删除的项是当前选中项, 并且删除项有下一项
                } else if (this.selectedComponent.fieldId === item.fieldId
                 && this.componentsList[index]) {
                    this.selectedComponent = this.componentsList[index]
                } else if (this.selectedComponent.fieldId === item.fieldId) {
                    this.selectedComponent = null
                }
            },

            // 下一步 表单设置
            next() {
                let tip = this.signupformVerify()
                if(tip) {
                    this.$message.warning(tip)
                    return
                }
                this.step ++
            },

            // 报名表校验
            signupformVerify() {
                // 活动信息校验
                if(this.activity.name === '') {
                    this.selectActivity()
                    return '请填写表单名称'
                } else if(this.activity.submitBtnTxt === '') {
                    this.selectActivity()
                    return '请输入按钮文案'
                }

                // 组件信息校验
                if(this.componentsList.length <= 0) {
                    return '请至少添加1个组件'
                }
                for(let i = 0; i < this.componentsList.length; i++) {
                    let item = this.componentsList[i]
                    // 校验标题
                    if (item.chName === '') {
                        this.selectComponent(i)
                        return `请输入组件${i + 1}的标题`
                    }
                    //  else if (item.isRequired === 1 && item.comment === '') { // 选了必填，但是没有设置提示信息
                    //     return `请输入组件${i + 1}的提示信息`
                    // }
                    // 校验选择题
                    if (item.name === 'choice') {
                        if (item.contents.length <= 0) {
                            this.selectComponent(i)
                            return `请添加组件${i + 1}的选项`
                        }
                        for(let j = 0; j < item.contents.length; j ++ ) {
                            if(item.contents[j].content === '') {
                                this.selectComponent(i)
                                return `请完善组件${i + 1}的选项`
                            }
                        }
                    }
                }
            },

            // 表单设置校验
            formsetVerify() {
                let formSetData = this.$refs.formSet.getActivityData()
                // if (formSetData.courseSourceId === '') {
                //     return '请关联直播'
                // }
                if (formSetData.courseSourceId&&formSetData.liveBeforeStatus === 0
                    && formSetData.liveBelowStatus === 0
                    && formSetData.liveNavigationStatus === 0) {
                    return '请选择表单入口'
                }
                if (formSetData.courseSourceId&&formSetData.liveBeforeStatus ===1
                    && formSetData.isAuth === 1) {
                    let componentsInfo = JSON.stringify(this.componentsList || [])
                    if (!componentsInfo.includes('certificatePhoto')) {
                        return '请在上一页中添加证件照'
                    }
                }
                if (formSetData.courseSourceId&&formSetData.liveBelowStatus === 1
                    && formSetData.liveIcon ==='') {
                    return '请设置把手入口图标'
                }
                if (formSetData.courseSourceId&&formSetData.liveNavigationStatus === 1
                    && formSetData.navigationName ==='') {
                    return '请设置导航名称'
                }
                return ''
            },

            // 保存表单
            save() {
                // 校验
                let tip = this.formsetVerify()
                if(tip) {
                    this.$message.warning(tip)
                    return
                }
                // 数据上传
                let data = this.activity // 活动信息
                data.fields = this.componentsList.concat(this.del_componentsList) // 组件
                let formSetData = this.$refs.formSet.getActivityData()
                data = Object.assign(data, formSetData)

                const key = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
                'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
                data.fields.forEach(item => {

                    // 处理自定义的filedId
                    if(!isNaN(item.fieldId)) {
                        item.fieldId = ''
                    }

                    // 处理选择题选项
                    if(item.name === 'choice' && item.contents && item.contents.length) {
                        item.contents.forEach((option, index) => {
                            option.item = key[index]
                        })
                    }
                })
                
                this.saveLoading = true
                let api = requestApi.save
                if(data.id) {
                    api = requestApi.update
                }
                if(!data.courseSourceId) delete data.courseSourceId
                // 接口调试
                api(data).then(res => {
                    if (res.Success||res.code.value===2000000) {
                        this.$message.success('保存成功')
                        this.closePage()
                    } else {
                        this.$message.error(res.Msg||res.message)
                    }
                }).finally(() => {
                    this.saveLoading = false
                })
            },
            
            // 关闭tab
            closePage() {
                let current = this.activity.id ? 'editform' : 'addform'
                this.$store.dispatch("tabs/removeSpecifiedTab", current)
                this.$store.dispatch("tabs/toTargetTab", "signupform")
            }
        }
    }
</script>

<style  type="text/less" lang="less" scoped>
    .form{
        display: flex;
        justify-content: space-between;
    }
    .left{
        flex: none;
        width: 284px;
    }
    .mid{
        flex: none;
        width: 366px;
        margin: 0 20px;
    }
    .right{
        width: 366px;
    }
</style>


// WEBPACK FOOTER //
// src/views/operateManage/signupform/components/form.vue